<template>
  <!-- 联系人列表 -->
  <ul>
    <li class="d-table w-100-p  b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in items" :key="item.logInId" @click="!showSelectedStatus && itemClickEvent(item)" v-if="((userInfo.mobile != item.mobile)&&showSelectedStatus || !showSelectedStatus) &&(!value||(value&&(item.nickName&&item.nickName.includes(value))||item.mobile&&item.mobile.includes(value)))">
      <div class="d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover p-relative" >
        <div class="d-table-cell v-a-middle h-100-p w-64" style="text-align: center;">
          <span class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">{{getShortNickname(item.nickName||item.mobile)}}</span>
        </div>
        <div class="d-table-cell v-a-middle h-100-p">
          <div :style="{width:listWidth+'px'}">
            <p class="t-ellipsis l-h-1-6-em m-r-10">{{item.nickName}}</p>
            <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500">{{item.mobile}}</p>
          </div>
        </div>
        <template v-if="showSelectedStatus">
          <input class="p-absolute top-0 right-0 bottom-0 left-0 o-0 w-100-p h-100-p" name="Fruit" type="checkbox" :value="item.logInId" v-model="selectedSessionsID" @change="onSelectedSessionChange(item)"/>
          <i class="d-inline-block m-t-22" v-if="selectedSessionsID.includes(item.logInId)">
            <img src="@/assets/images/im/selectedSession@2x.png" style="width:22px;height:22px;"/>
          </i>
          <i class="d-inline-block m-t-22" v-else>
            <img src="@/assets/images/im/unSelectedSession@2x.png" style="width:22px;height:22px;"/>
          </i>
        </template>
      </div>
    </li>
  </ul>
</template>
<script>
import { getStore } from '@/utils/localStorage';
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return [];
      }
    },
    width: {
      type: Number,
      default: 185
    }
  },
  data: function () {
    return {
      listWidth: 185,
      selectedSessionsID:[],
      showSelectedStatus: this.$attrs.showSelectedStatus || false,
      userInfo: JSON.parse(getStore('userInfo'))
    };
  },
  mounted: function () {
  },
  methods: {
    // 用户信息
    getUserRole: function (item) {
      var str = '';
      str += item.nickName && item.nickName !== '无' ? ' ' + item.nickName : '';
      return str;
    },
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    // 点击联系人
    itemClickEvent: function (item) {
      // console.log(item, 'user-in-createSession-in-contact-list');
      document.querySelector('#imLayout').click();
      this.$emit('createSession', item);
      this.bus.$emit("selectNewsTab");
    },
    onSelectedSessionChange(item){
      if(this.selectedSessionsID.includes(item.logInId)){
        this.$emit('createSession', item);
      }else{
        this.$emit('delSelectedSession', {
          delItem: item,
          keyName: "logInId"
        });
      }
    }
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    },
    "$attrs.reverseDelSession"(newVal){
      if(Object.keys(newVal).length > 0){
        //点击右侧的删除，反向删除左侧选中的列表
        let index = this.selectedSessionsID.findIndex(item=>{
          return item == newVal.logInId
        })
        this.$delete(this.selectedSessionsID,index);
      }
    },
    "$attrs.visible"(newVal){
      if(!newVal){
        this.selectedSessionsID = [];
      }
    },
  }
}
</script>
